import { createConsumer } from '@rails/actioncable';

let consumer: ReturnType<typeof createConsumer> | null = null;

export function getConsumer() {
  if (!consumer) {
    consumer = createConsumer();
  }
  return consumer;
}
